"use client";

import { useState } from "react";
import { X } from "lucide-react";

export default function PromoBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="relative z-50 bg-yellow-400 text-black text-xs py-1.5 px-4 text-center">
      <p className="font-medium">
        Use code{" "}
        <span className="font-bold bg-black/10 rounded px-1.5 py-0.5 tracking-wide">
          DS20
        </span>{" "}
        to get{" "}
        <span className="font-bold">20% off</span>{" "}
        Pro &amp; Elite plans.{" "}
        <a
          href="/#pricing"
          className="underline underline-offset-2 font-semibold hover:text-black/60 transition-colors"
        >
          Claim now →
        </a>
      </p>
      <button
        onClick={() => setDismissed(true)}
        aria-label="Dismiss banner"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-black/10 transition-colors"
      >
        <X size={16} />
      </button>
    </div>
  );
}
